import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchNotesToReviewTypes = getApiActionTypes('FETCH_NOTES_TO_REVIEW');
export const deleteNoteTypes = getApiActionTypes('DELETE_NOTE');
export const fetchJurisdictionsTypes = getApiActionTypes('FETCH_JURISDICTIONS');
export const fetchStatusesTypes = getApiActionTypes('FETCH STATUSES');
export const fetchTasksTypes = getApiActionTypes('FETCH_TASKS');
export const createNoteTypes = getApiActionTypes('ADD_NOTE');
export const updateNoteTypes = getApiActionTypes('UPDATE_NOTE');
